import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    outline: 0;
  }

  body,
  input,
  textarea,
  button {
    font: 400 16px "Source Sans Pro", Arial, sans-serif;
  }

  a {
    color: ${props => props.theme.colors.white};
    text-decoration: none;
  }

  @media(max-width: 1080px) {
    html {
      font-size: 93.75%;
    }
  }

  @media(max-width: 720px) {
    html {
      font-size: 87.5%;
    }
  }

  body {
    background: ${props => props.theme.backgrounds.dark};
    color: ${props => props.theme.colors.white};
  }
`